<template>
    <div id="ch_popup_gallery" class="modal-block fade" role="dialog">
        <div class="modal-dialog message-modal" role="document">
            <div class="modal-content" v-if="d_candy">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
                <div class="modal-content-block">
                    <div class="gallery-carrousel" v-if="d_candy.JsonImages && Array.isArray(d_candy.JsonImages)">
                        <div ref="slider" class="gallery-carrousel-inner">
                            <div v-for="(data, index) in d_candy.JsonImages" :key="index">
                                <div class="gallery-image">
                                    <div class="panzoom-element">
                                        <img :src="getImageUrl(data.Image)" class="img-responsive" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import $ from "jquery";

  import Panzoom from './../assets/panzoom.min.js';

  require("./../assets/jquery.bpopup.min.js");
  require('slick-carousel');

  export default {
    name: "popupgalleryhome",
    data() {
      return {
        isOpenedBefore: null
      };
    },
    props: {
      d_candy: { type: Object, default: () => null }
    },
    computed: {
      c_candy: {
        get() {
          return this.d_candy;
        },
        set(a) {
          this.d_candy = a;
        }
      }
    },
    updated() {
      $(this.$refs.slider).not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 1,
        dots: false,
        arrows: true,
        slidesToScroll: 1,
        draggable: false,
        swipe: true
      });
      
      const elements = document.querySelectorAll('.panzoom-element');
      
      elements.forEach(elem => {
        let touchStartTime = 0;
        let zoomed = false;
        const touchDelay = 300; // Retraso en milisegundos para detectar el doble toque

        const panzoom = Panzoom(elem, {
          panOnlyWhenZoomed: true,
          minScale: 1,
          startScale: 1,
          contain: 'outside',
          cursor: 'default'
        });

        elem.addEventListener('wheel', event => {
          panzoom.zoomWithWheel(event);
        });

        elem.addEventListener('touchstart', event => {
          const currentTime = new Date().getTime();
          const timeDiff = currentTime - touchStartTime;

          if (timeDiff < touchDelay) {
              // Se ha realizado un doble toque
              if (zoomed) {
                  // Restaurar la escala a 1
                  panzoom.zoomToPoint(1, {
                    clientX: event.touches[0].clientX,
                    clientY: event.touches[0].clientY
                  });
                  zoomed = false;
              }
              else {
                // Realizar acciones de panzoom aquí
                panzoom.zoomToPoint(4, {
                  clientX: event.touches[0].clientX,
                  clientY: event.touches[0].clientY
                });
                zoomed = true;
              }
          }

          touchStartTime = currentTime;
        });

        elem.addEventListener('panzoomzoom', (event) => {
          if(event.detail.scale > 1) {
            elem.style.cursor = 'grab';

            $(this.$refs.slider).slick('slickSetOption', 'swipe', false, true);
          }
          else {
            elem.style.cursor = 'default';

            $(this.$refs.slider).slick('slickSetOption', 'swipe', true, true);
          }
        });
      });
    },
    methods: {
      getImageUrl(imageName) {
        let baseUrl = this.$root.d_get_url_candy_images;
        let version = this.$root.d_get_date_version_cache;
        return `${baseUrl}${imageName}?v=${version}`;
      },
      //Seteo el object con los atributos a mostrar.
      m_open: function (args) {
        this.d_candy = args;       
        var bPopup = $(this.$el).bPopup({
          positionStyle: 'fixed',
          position: [0, 0],
          closeClass: "close",
          onOpen: function() {
            $('body').css('overflow', 'hidden');
          },
          onClose: function() {
            // Restablecer el estilo overflow del body cuando se cierra el popin
            $('body').css('overflow', 'initial');
            $(this.$el).remove();
          }
        });

        if (this.isOpenedBefore != null) {
          if(this.d_candy.strMCode != this.isOpenedBefore.strMCode) {
            this.isOpenedBefore = this.d_candy;

            //Refresco el slider de la galeria
            if ($(this.$refs.slider).hasClass('slick-initialized')) {
              $(this.$refs.slider).slick('unslick');
            }
          }
          else {
            // Cambiar a la primera posición del slider
            $(this.$refs.slider).slick('slickGoTo', 0)
          }
        }
        else {
          this.isOpenedBefore = this.d_candy;
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/PopupGalleryHome.vue